import './ServicesSection.css';

function ServicesSection() {
  return (
    <section id="servicos" className="services-section">
      <h2 className="fade-in" style={{ animationDelay: '0.2s' }}>Nossos Serviços</h2>
      <div className="service-cards">
        <div className="service-card slide-in-left" style={{ animationDelay: '0.4s' }}> {/* Animação no card */}
          <i className="fas fa-cube service-icon"></i>
          <h3>Impressão 3D</h3>
          <p>Oferecemos serviços de impressão 3D de alta qualidade para protótipos, peças personalizadas, brindes e muito mais. Dê vida aos seus projetos com a tecnologia aditiva!</p>
        </div>
        <div className="service-card fade-in" style={{ animationDelay: '0.6s' }}> {/* Animação no card */}
          <i className="fas fa-laptop-code service-icon"></i>
          <h3>Desenvolvimento de Sites</h3>
          <p>Criamos sites modernos, responsivos e otimizados, garantindo sua presença online e o alcance de seu público-alvo com design profissional e funcionalidade impecável.</p>
        </div>
        <div className="service-card slide-in-right" style={{ animationDelay: '0.8s' }}> {/* Animação no card */}
          <i className="fab fa-android service-icon"></i>
          <h3>Aplicativos Android</h3>
          <p>Desenvolvemos aplicativos Android personalizados para atender às suas necessidades específicas, desde apps corporativos a soluções inovadoras para o dia a dia, com foco em usabilidade e performance.</p>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;